import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as constants from '../../../constants-types/constants';
import { ODataSearchState } from '../../../core-services/odata/odata.models';
import { UserProfileSettingsService } from '../../../system-services/UserProfileSettings/UserProfileSettings.service';
import { TranslationService } from '../../../translations/Translation.service';
@Component({
    selector: 'odata-pager-size-picker',
    template: ` <div class="pi-pagination_resultsToggle">
        {{ TR.key('tablePager.resultsPerPage') }}
        @for (resultsCount of resultsPerPageOptions; track resultsCount) {
            <a
                [ngClass]="{
                    'lsg-link': pagingData.resultsPerPage !== resultsCount,
                    'lsg-link--disabled':
                        pagingData.resultsPerPage === resultsCount
                }"
                (click)="setResultsPerPage(resultsCount)"
            >
                {{ resultsCount }}
            </a>
        }
    </div>`,
    standalone: false
})
export class ODataPagerSizePickerComponent {
    @Input()
    searchState: ODataSearchState<any>;
    @Output()
    onResultsSizeChange: EventEmitter<number> = new EventEmitter();

    resultsPerPageOptions = [
        constants.tableDefaultResultsPerPage,
        constants.serverApiMaxResults
    ];
    resultsPerPage = this.resultsPerPageOptions[0];

    constructor(
        public TR: TranslationService,
        private userProfileSettings: UserProfileSettingsService
    ) {}

    get pagingData() {
        return this.searchState?.oDataSearch.pageInfo;
    }

    setResultsPerPage(resultsPerPage: number): void {
        this.userProfileSettings.preferredPageSize = resultsPerPage;
        this.onResultsSizeChange.emit(resultsPerPage);
    }
}
